import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';

import { Observable } from 'rxjs/Observable';
import { switchMap, take, tap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/observable/fromPromise';

import {User, Subscription } from './core.model';
import { StateService } from './state.service';
import {CheckitEvent, PurchaseTransaction} from "../pages/checkit-dashboard/checkit.model";
import {PureExpressionData} from "@angular/core/src/view";
import {Subject} from "rxjs";

@Injectable()
export class AuthService {

    user: Observable<User>;
    error: Observable<any>;
    is_create_user = false; // for temporary auth, used when creating a user, and routing definition
    subscription: Subscription;
    user_country: string;
    creating_user = false;
    signing_in = false;
    password_email_reset_error: string;
    password_email_reset = false;
    password_email_reset_loading = false;

    public $destroy: Subject<boolean> = new Subject();
    public $errors: Subject<boolean> = new Subject();

    // accessToken;

    constructor(private afAuth: AngularFireAuth,
                public afs: AngularFirestore,
                private router: Router,
                private state: StateService
    ) {
        afs.firestore.settings({timestampsInSnapshots: true});
        //// Get auth data, then get firestore user document || null
        this.user = this.afAuth.authState.pipe(
            switchMap(user => {
                if (user) {
                    return this.afs.doc<User>(`users/${user.uid}`).valueChanges()
                } else {
                    return Observable.of(null)
                }
            })
        );
        this.user.takeUntil(this.$destroy).subscribe(user => {
            console.log('updated user ', user)
            if(user && user.currentAccount){
                this.user_country = user.country || 'Australia';
                const settings = {
                    view_closed_events:!user.hide_closed_events
                }
                console.log('user settings ', settings)
                this.afs.doc<any>(`accounts/${user.currentAccount}`)
                    .valueChanges().map( acc => acc.subscription)
                    .takeUntil(this.$destroy)
                    .subscribe(subscription => this.subscription = subscription);
                this.state.setAccount('currentId', user.currentAccount, user.uid, settings);
                this.creating_user = false;
            }
        });
    }

    googleLogin() {
        const provider = new firebase.auth.GoogleAuthProvider();
        //provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
        return this.oAuthLogin(provider);
    }

    private oAuthLogin(provider) {
        return this.afAuth.auth.signInWithPopup(provider)
            .then(credential => {
                console.log(credential);
                let user = credential.user
                if (credential && credential.additionalUserInfo && credential.additionalUserInfo.profile) {
                    user.firstName = credential.additionalUserInfo.profile.given_name;
                    user.lastName = credential.additionalUserInfo.profile.family_name;
                }
                this.updateUserData(user);
            })
    }

    signInWithEmailAndPassword(email, password){
        var self = this
        this.afAuth.auth.signInWithEmailAndPassword(email,password)
            .then(user => {
                this.updateUserData(user);
            })
            .catch(error => {
                self.signing_in = false;
                self.$errors.next(error);
                self.error = Observable.of(error);
            })
    }
    createUser(email, password, user_obj = {}){
        var self = this
        return this.afAuth.auth.createUserWithEmailAndPassword(email, password)
            .then(user => {
                let newuser = Object['assign']({}, user, user_obj);
                this.updateUserData(newuser)
            })
            .catch(function(error) {
                self.creating_user = false;
                self.$errors.next(error);
                self.error = Observable.of(error);
            });
    }

    anonymousLogin() {
        return this.afAuth.auth.signInAnonymously()
            .then(user => {
                this.updateUserData(user)
            })
    }

    // Sets user data to firestore on login
    private updateUserData(user) {
        const userDoc: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
        const data: User = {} as User;
        data['uid'] = user.uid;
        if (user.email) data['email'] = user.email;
        if (user.firstName) data['firstName'] = user.firstName;
        if (user.lastName) data['lastName'] = user.lastName;
        if (user.displayName) data['displayName'] = user.displayName;
        if (user.photoURL) data['photoURL'] = user.photoURL;
        if (user.country) data['country'] = user.country;
        const date = new Date();
        data['lastLogin'] = date;
        data['UTCOffset'] = date.getTimezoneOffset();
        userDoc.set(data, { merge: true })
        this.signing_in = false;
    }

    signOut() {
        this.afAuth.auth.signOut().then(() => {
            this.state.cleanState();
            // I think we need to kill the user here but I am not sure how
            this.$destroy.next();
            this.router.navigate(['/']);
        });
    }

    // Used by the http interceptor to set the auth header
    getUserIdToken(): Observable<string> {
        return fromPromise ( this.afAuth.auth.currentUser.getIdToken() );
    }

    sendPasswordResetEmail(email){
        var actionCodeSettings = {
            url: 'https://dev.checkit.events/checkit-dashboard',
            handleCodeInApp: true
        };

        var self = this
        this.password_email_reset_loading = true;
        this.afAuth.auth.sendPasswordResetEmail( email, actionCodeSettings)
            .then(function() {
                // Password reset email sent.
                self.password_email_reset = true;
                self.password_email_reset_loading = false;
            })
            .catch(function(error) {
                self.password_email_reset_error = error.message;
                self.password_email_reset_loading = false;
            });
    }
    /*confirmPasswordReset(code, newPassword){
        this.afAuth.auth.confirmPasswordReset(code, newPassword)
            .then(rtn=>{
                console.log('rtn ',rtn)
            })
            .catch(function(error) {
                console.log('confirmPasswordReset error ',error)
            });
    }*/

    ///// STRIPE CONNECT //////


    // Login popup window
    stripeLogin() {
        const popup = window.open(`${environment.functionsURL}/stripeRedirect`, '_blank', 'height=700,width=800')
    }
    // Signin with a custom token from
    customSignIn(token) {
        return this.afAuth.auth.signInWithCustomToken(token).then(() => window.close())
    }

}


// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts